import { render, staticRenderFns } from "./rejected-status-description.vue?vue&type=template&id=01420a8c"
import script from "./rejected-status-description.vue?vue&type=script&lang=js"
export * from "./rejected-status-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports